// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import {
  IFrameAwareDropdownMenu,
  MenuMaker,
} from "@/wab/client/components/widgets";
import { PlasmicMenuButton } from "@/wab/client/plasmic/plasmic_kit_design_system/PlasmicMenuButton";
import * as React from "react";

interface MenuButtonProps {
  menu?: React.ReactNode | MenuMaker;
  className?: string;
  style?: React.CSSProperties;
  onVisibleChange?: (visible: boolean) => void;
  onContextMenu?: (e: React.MouseEvent) => void;
  tabIndex?: number;
}

function MenuButton(props: MenuButtonProps) {
  const {
    menu,
    className,
    style,
    onVisibleChange,
    onContextMenu,
    ...extraProps
  } = props;
  if (!menu && !onContextMenu) {
    return null;
  }
  const button = (
    <PlasmicMenuButton
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        onContextMenu?.(e);
      }}
      className={className}
      style={style}
      {...extraProps}
    />
  );
  return onContextMenu ? (
    button
  ) : (
    <IFrameAwareDropdownMenu menu={menu} onVisibleChange={onVisibleChange}>
      {button}
    </IFrameAwareDropdownMenu>
  );
}

export default MenuButton;
